import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchLocations = createAsyncThunk('locations/fetchAll', async () => {
  const { data } = await client.get('/locations/');
  return data;
});

export const fetchRooms = createAsyncThunk('locations/fetchRooms', async (locationId) => {
  const { data } = await client.get(`/locations/${locationId}/rooms/`);
  return { locationId, rooms: data };
});

const locationsSlice = createSlice({
  name: 'locations',
  initialState: { list: [], rooms: {}, loading: false, error: null },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchLocations.pending, state => { state.loading = true; })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.results || action.payload;
      })
      .addCase(fetchRooms.fulfilled, (state, action) => {
        state.rooms[action.payload.locationId] = action.payload.rooms;
      });
  }
});

export default locationsSlice.reducer;
